import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { GetDirectDebits } from '@/graphql/contracts/_generated_/getDirectDebits.query';
import GetDirectDebitsQueary from '@/graphql/contracts/getDirectDebits.query.gql';

export function getDirectDebits(): DirectDebit[] {
  const result = apolloClientContracts.readQuery<GetDirectDebits>({
    query: GetDirectDebitsQueary
  });

  return result?.directDebits || [];
}
